<template>
	<transition name="slide-fade">
		<div class="bottom-sheet" v-if="opened">
			<div class="sheet bg-00dp">
				<div class="head">
					<div class="btn btn-back" @click="close">
						<div class="icon icon-left-open-mini"></div>
					</div>
					<slot name="head"></slot>
				</div>

				<div class="content">
					<slot></slot>
				</div>
				<div class="foot">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "PopupPage",
	props: {
		title: "",
		closeOnBackdrop: {
			default: true
		}
	},
	created() {
		window.addEventListener("popstate", this.popstateEventAction)
	},
	data() {
		return {
			opened: false,
			animate: false
		}
	},
	methods: {
		open() {
			this.opened = true
		},
		close() {
			this.opened = false
		},
		closeBackdrop() {
			if (this.closeOnBackdrop) {
				this.hide()
			}
			this.$emit("cancelled")
		},
		popstateEventAction() {
			// ... some action triggered when the back button is clicked
			console.log("popstateEventAction")
			this.removePopstateEventAction()
		},
		removePopstateEventAction() {
			window.removeEventListener("popstate", this.popstateEventAction)
		}
	}
}
</script>

<style scoped lang="scss">
.btn-back {
	display: flex;
	align-items: center;
	.icon {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #fff;
	}
}
.bottom-sheet {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100%;
	z-index: 1030;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
}
.sheet {
	width: 100%;
	height: 100vh;
	z-index: 1300;
	display: flex;
	flex-direction: column;
}
.sheet .head {
	width: 100%;
	height: 34px;
	display: flex;
	align-items: center;
	padding-left: 10px;
}
.sheet .head h1 {
	font-size: 16px;
	font-weight: 600;
}
.sheet .content {
	padding: 12px;
	overflow: auto;
	/* height: calc( 100vh - 150px); */
	margin-top: 52px;
	flex-grow: 1;
}
.sheet .foot {
	padding: 8px 12px;
}

.slide-fade-enter-active {
	transition: all 0.2s ease;
}
.slide-fade-leave-active {
	transition: all 0.3s;
	/* transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
}
.slide-fade-enter,
.slide-fade-leave-to {
	transform: translateX(30px);
	opacity: 0;
}

.backdrop {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1040;
	width: 100vw;
	height: 100vh;
	background-color: #00000060;
	opacity: 1;
	/* -webkit-backdrop-filter: blur(1.5px);
    backdrop-filter: blur(1.5px); */
	-webkit-transition: all 0.1s ease-in-out;
	-moz-transition: all 0.1s ease-in-out;
	-o-transition: all 0.1s ease-in-out;
	transition: all 0.1s ease-in-out;
}

.content::-webkit-scrollbar,
.content::-webkit-scrollbar-thumb {
	display: none;
}
</style>
